import React from 'react';
import TextWinds from '../common/TextWinds';
import CustomRadios from '../common/CustomRadios';
import { PaymentMethod as PaymentMethodEnum } from '../../enum';
interface PaymentsProps {
  paymentMethod: PaymentMethodEnum | '';
  onPaymentMethodChange: (id: PaymentMethodEnum) => void;
}

/**
 * 결제 페이지 - 결제수단 선택 영역 컴포넌트
@description
 */
const PaymentMethod = ({
  paymentMethod,
  onPaymentMethodChange,
}: PaymentsProps) => {
  const handlePaymentMethodChange = (id: string) => {
    console.log('[PaymentMethod] id:', id);
    onPaymentMethodChange(id as PaymentMethodEnum);
  };

  return (
    <div className="mt-[16px] bg-white px-[20px] py-[14px] xl:rounded-[8px]">
      <TextWinds type="title_h4">결제수단</TextWinds>
      <ul className="mt-[16px] grid gap-[16px] md:grid-cols-3">
        <CustomRadios
          id={PaymentMethodEnum.CREDIT_CARD}
          color="purple5"
          target={paymentMethod}
          onChange={handlePaymentMethodChange}
        >
          <TextWinds
            type="content_bold"
            color={`${
              PaymentMethodEnum.CREDIT_CARD === paymentMethod
                ? 'white'
                : 'purple5'
            }`}
          >
            신용카드
          </TextWinds>
        </CustomRadios>
        <CustomRadios
          id={PaymentMethodEnum.BANK_TRANSFER}
          color="purple5"
          target={paymentMethod}
          onChange={handlePaymentMethodChange}
        >
          <TextWinds
            type="content_bold"
            color={`${
              PaymentMethodEnum.BANK_TRANSFER === paymentMethod
                ? 'white'
                : 'purple5'
            }`}
          >
            실시간 계좌이체
          </TextWinds>
        </CustomRadios>
        <CustomRadios
          id={PaymentMethodEnum.DEPOSIT}
          color="purple5"
          target={paymentMethod}
          onChange={handlePaymentMethodChange}
        >
          <TextWinds
            type="content_bold"
            color={`${
              PaymentMethodEnum.DEPOSIT === paymentMethod ? 'white' : 'purple5'
            }`}
          >
            무통장 입금 (가상계좌)
          </TextWinds>
        </CustomRadios>
      </ul>
    </div>
  );
};

export default PaymentMethod;
